export class CookieHelper {
	public create(name: string, value: string | number | boolean, days: number = null) {
		let expires;
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toUTCString();
		} else {
			expires = '';
		}
		document.cookie = name + '=' + value + expires + '; path=/';
	}

	// making a new one because I don't know if I'm going to break something if I edit the one above
	public createReturn(name: string): string | null {
		const regex = `(?:(?:^|.*;)\\s*${encodeURIComponent(name).replace(/[-.+*]/g, '\\$&')}\\s*\\=\\s*([^;]*).*$)|^.*$`;
		const cookieValue = decodeURIComponent(document.cookie.replace(new RegExp(regex), '$1'));

		return cookieValue || null;
	}

	public get(name: string): string | null {
		if (document.cookie.length > 0) {
			let start = document.cookie.indexOf(name + '=');
			if (start !== -1) {
				start = start + name.length + 1;
				let end = document.cookie.indexOf(';', start);
				if (end === -1) {
					end = document.cookie.length;
				}
				return unescape(document.cookie.substring(start, end));
			}
		}
		return null;
	}
}
